export default "__VITE_ASSET__844828c4__"